import type { OrderItemsEntity } from "./OrderItemsEntity";

export class UpdateOrderItemEntity {
  newItems?: { item?: OrderItemsEntity; quantity?: number }[]
  deletedItems?: string[]
  updatedItems?: { id: string; quantity?: number }[]
}